// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".blocked-form__message[data-v-08333e42]{color:#f56123;font-size:11px}.blocked-form__message .blocked-form__cookies-trigger[data-v-08333e42]{cursor:pointer}", ""]);
// Exports
module.exports = exports;
